import React, { ReactNode } from 'react'

import { twMerge } from '../../tailwind/merge'
import { Box } from '../box'
import { HStack } from '../hstack'
import { Text } from '../text'

export type HeaderContainerProps = {
    title: ReactNode
    titleCount?: number | string
    leftButton?: ReactNode
    rightButton?: ReactNode
    rightButtonVisible?: boolean
    children?: ReactNode
    testID?: string
}

export const HeaderContainer = ({
    title,
    titleCount,
    leftButton,
    rightButton,
    rightButtonVisible = true,
    children,
    testID = 'simple-header',
}: HeaderContainerProps) => (
    <HStack className='h-full flex-1 items-center' testID={testID}>
        {leftButton}
        <HStack
            className={twMerge('h-full min-w-[200px] flex-1 items-center', leftButton && 'pl-2')}
        >
            <Box className='h-full flex-1 justify-center'>
                {typeof title === 'string' ? (
                    <Text size='H1' weight='light' tone='default' numberOfLines={1}>
                        {title}
                    </Text>
                ) : (
                    title
                )}
            </Box>
            {titleCount !== undefined && titleCount !== null && (
                <Text size='H1' weight='light' tone='muted'>
                    {` (${titleCount})`}
                </Text>
            )}
        </HStack>
        {children}
        {rightButton && rightButtonVisible && <Box className='pl-5'>{rightButton}</Box>}
    </HStack>
)

HeaderContainer.displayName = 'HeaderContainer'
